import MuiTextField from '@material-ui/core/TextField';
import {Field} from 'formik';
import {
  Autocomplete,
  AutocompleteRenderInputParams,
} from 'formik-material-ui-lab';
import React, {useEffect, useState} from 'react';

// interface FormikAutocompleteProps {
//   name: string,
//   options: any[],
//   displayValue: string,
//   keyValue: string,
//   label: string
//   formikProps: any,
//   fullWidth:string,
//   disabled:boolean,
//   multiName: boolean,
//   lookupColumn: any,
//   user: string | null,
//   typeOfForm: any,
// }

const FormikAutocomplete = (props: any) => {
  const {
    name,
    options,
    displayValue,
    keyValue,
    label,
    formikProps,
    fullWidth,
    disabled,
    multiName = false,
    lookupColumn,
    user = null,
    typeOfForm,
  } = props;
  const {touched, errors, setFieldValue, submitCount}: any = formikProps;
  const [value, setValue] = useState(null);
  const showError = Boolean(errors[name]) && (touched[name] || submitCount > 0);
  const helperText = showError ? errors[name] : undefined;

  useEffect(() => {
    if (user != null && name === 'sector' && typeOfForm !== 'edit') {
      const result = options.find((obj: any) => {
        return obj[keyValue] === user.iD_Sector;
      });
      if (typeof result !== 'undefined') {
        setValue(result);
        setFieldValue(name, user.iD_Sector);
      }
    }

    let id = formikProps.values[name];

    const result = options.find((obj: any) => {
      return obj[keyValue] === id;
    });
    if (typeof result !== 'undefined') {
      setValue(result);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Field
      component={Autocomplete}
      name={name}
      options={options}
      getOptionLabel={(option: any) => {
        if (typeof option[displayValue] === 'undefined') {
          return '';
        } else {
          if (multiName === true) {
            if (name === 'iD_Course' && typeof lookupColumn !== 'undefined') {
              return `${option[displayValue]} - V${option[lookupColumn]}`;
            } else {
              return `${option[lookupColumn]} - ${option[displayValue]}`;
            }
          }
          return option[displayValue];
        }
      }}
      value={value}
      onChange={(_: any, value: any) => {
        setValue(value);
        if (value !== null) {
          setFieldValue(name, value[keyValue]);
        } else {
          setFieldValue(name, '');
        }
      }}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <MuiTextField
          {...params}
          error={showError}
          helperText={helperText}
          label={label}
          disabled={disabled}
          fullWidth={fullWidth}
          variant="outlined"
        />
      )}
    />
  );
};

export default FormikAutocomplete;
